export default "__VITE_ASSET__CPVrXxgu__"